import gql from 'graphql-tag'

export const LOGGING = gql`
mutation userActionsLog($input: CreateUserActionsLog!) {
    userActionsLog(input: $input) {
    isSuccessful
    message
  }
}
`
